<template>
	<el-dialog :visible.sync="visible" :before-close="handleCancel" :close-on-click-modal="false" :close-on-press-escape="false">
		<span slot="title">{{`上傳${title}照片(至多五張，每張最大5MB)`}}</span>
		<upload v-if="visible" ref="uploader" :title="title" />
		<el-row slot="footer" type="flex" justify="end">
			<el-button @click="handleCancel()" type="info">取消</el-button>
			<el-button @click="handleSave()" type="danger">確定</el-button>
		</el-row>
	</el-dialog>
</template>

<script>
import Upload from "@/components/challenge/signUp/editStory/Upload.vue";
export default {
	props: ["title", "visible"],
	components: { Upload },
	data() {
		return {};
	},
	methods: {
		handleCancel() {
			this.$emit("update:visible", false);
		},
		async handleSave() {
			try {
				await this.$refs["uploader"].handleSave();
				this.$emit("update:visible", false);
			} catch (e) {
				this.$message.error(e);
			}
		}
	}
};
</script>